import { Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { UiObject } from "@models/configurators/ui-object";
import { ITab, IMedia } from "@models/entity-models";
import { KbObjectManager } from "@models/configurators/kb-object-manager";

@Kbo(CToken.Media)
export class Media extends UiObject implements IMedia {

    constructor(kom: KbObjectManager) {
        super(kom);
    }
    
    public mediaPath: string;
}
